module.exports = __webpack_public_path__ + "static/media/about-02.52d92ed5.jpg";